import * as actions from './actions';

const initialState = {
    error: null,
    initial: false,
    tags: [],
    loading: false,
};

export default function tagsReducer(state = initialState, action) {
    switch (action.type) {
        // fetch
        case actions.FETCH_TAGS.REQUEST:
            return { ...state, error: null, loading: true };

        case actions.FETCH_TAGS.SUCCESS:
            return { ...state, initial: true, tags: action.payload, loading: false };

        case actions.FETCH_TAGS.FAILURE:
            return { ...state, initial: false, error: action.payload, loading: false };

        default:
            return state;
    }
}